import React from 'react';
import { StaticImage } from "gatsby-plugin-image";
import * as classes from './Landing.module.css';

function Landing() {
  return (
    <div>
      <StaticImage
        src="../../images/banner.jpg"
        alt="Recover Banner"
        placeholder="blurred"
        className={classes.image}
      />
    </div>
  )
}

export default Landing;